var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState, } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import generateID from "../../../utils/string-utils";
import "@gouvfr/dsfr/dist/component/form/form.css";
import "@gouvfr/dsfr/dist/component/input/input.css";
var PassWord = function (props) {
    var _a, _b;
    var label = props.label, hint = props.hint, message = props.message, messageType = props.messageType, className = props.className, required = props.required, onBlur = props.onBlur, autoValidation = props.autoValidation, id = props.id, remainingProps = __rest(props, ["label", "hint", "message", "messageType", "className", "required", "onBlur", "autoValidation", "id"]);
    var _c = useState({
        status: "",
        message: undefined,
    }), validation = _c[0], setValidation = _c[1];
    var _d = useState(false), passwordShown = _d[0], setPasswordShown = _d[1];
    var togglePassword = function () {
        setPasswordShown(!passwordShown);
    };
    var internalMessageType = autoValidation ? validation.status : messageType;
    var internalMessage = autoValidation ? validation.message : message;
    var _classNameWrapper = classNames("fr-input-group", (_a = {},
        _a["fr-input-group--".concat(internalMessageType)] = internalMessageType,
        _a), className);
    var _className = classNames("fr-input", (_b = {},
        _b["fr-input--".concat(internalMessageType)] = internalMessageType,
        _b));
    var inputId = useRef(id || generateID());
    var hintId = useRef(generateID());
    return (React.createElement("div", { className: _classNameWrapper },
        label && (React.createElement("div", { className: "d-login-flex" },
            React.createElement("div", null,
                React.createElement("label", { className: "fr-label", htmlFor: inputId.current, "aria-describedby": hint && hintId.current },
                    label,
                    required && React.createElement("span", { className: "error" }, " *"))),
            React.createElement("div", { className: "icons", onClick: togglePassword },
                React.createElement("span", { className: "fr-icon-eye-line", "aria-hidden": "true" }),
                "Afficher"))),
        hint && (React.createElement("p", { className: "fr-hint-text", id: hintId.current }, hint)),
        React.createElement("input", __assign({}, remainingProps, { className: _className, id: inputId.current, type: passwordShown ? "text" : "password", required: required, onBlur: function (e) {
                if (autoValidation) {
                    setValidation({
                        status: e.target.validity.valid ? "valid" : "error",
                        message: e.target.validationMessage,
                    });
                }
                if (onBlur)
                    onBlur(e);
            } })),
        internalMessage && internalMessageType && (React.createElement("p", { className: "fr-".concat(internalMessageType, "-text") }, internalMessage))));
};
PassWord.defaultProps = { __type: "PassWordInput" };
PassWord.propTypes = { __type: PropTypes.string };
export default PassWord;
